import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import FormularioMobile from './components/FormularioMobile';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import GenerarPDF from './components/GenerarPDF';
import './App.css';

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('adminToken');
    return token ? children : <Navigate to="/admin" />;
};

const EditarFormulario = () => {
    const { id } = useParams();
    return <FormularioMobile editMode={true} formId={parseInt(id)} />;
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<FormularioMobile />} />
                <Route path="/admin" element={<Login />} />
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/pdf/:id" element={<PrivateRoute><GenerarPDF /></PrivateRoute>} />
                <Route path="/editar/:id" element={<PrivateRoute><EditarFormulario /></PrivateRoute>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
